<div class="ui-project__header">
  <h5 class="font-weight-bold mb-0">{{ 'ProjectTeam.List.title' | translate }}</h5>

  <div class="actions__buttons">
    <ng-container *appHasRole="defaultPanelRoles">
      <app-button
        (onClick)="addNewTeamMember()"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.PRIMARY_BLUE,
          prependSrc: './assets/img/ic-user-plus.svg'
        }"
      />
    </ng-container>
    <list-search />
    <list-filters-btn-v2 [filters]="ProjectTeamFiltersComponent" />
  </div>
</div>

<div class="container-fluid--30 pt-3 px-0">
  <app-list
    *ngIf="inited"
    [config]="config"
    [filters]="ProjectTeamFiltersComponent"
    [emptyTemplate]="emptyTemplate"
    [searchName]="'ProjectTeam.List.search' | translate"
    [selected]="selected"
    [showToggleMenu]="showToggleMenu.bind(this)"
    #list
  />
</div>

<ng-template #emptyTemplate>
  <app-empty-list
    [imageSrc]="'/assets/img/empty-contacts.svg'"
    [imageAlt]="'ProjectTeam.List.noRecords' | translate"
    [title]="'ProjectTeam.List.emptyTitle' | translate"
    [subtitle]="'ProjectTeam.List.emptyDescription' | translate"
  >
    <ng-container *appHasRole="defaultPanelRoles">
      <app-button
        (onClick)="addNewTeamMember()"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.PRIMARY_BLUE,
          text: 'ProjectTeam.addNewTeamMember' | translate,
          prependSrc: './assets/img/ic-user-plus.svg'
        }"
      />
    </ng-container>
  </app-empty-list>
</ng-template>

<project-team-employee-cell #projectTeamEmployeeCellComponent />
<project-team-function-cell #projectTeamFunctionCellComponent />
<project-team-phone-cell #projectTeamPhoneCellComponent />
<project-team-hourly-rate-cell #projectTeamHourlyRateCellComponent />
<project-team-role-cell #projectTeamRoleCellComponent />
<project-team-role-project-cell #projectTeamRoleProjectCellComponent />
<project-team-email-cell #projectTeamEmailCellComponent />
